import React from 'react'
import {
  Grid,
  Card,
  CardContent,
  Button,
  Typography,
  IconButton
} from '@material-ui/core'
import { useRequestCardStyles } from './requestCards.styles'
import { useRoutes } from 'hooks'
import { useHomeStore } from 'context/HomeStore'
import { getNotification, tableStatusBtns } from '../const'
import clsx from 'clsx'
import { ArrowForward } from '@material-ui/icons'
import { REQUEST_PATH } from 'routes/constants.routes'
import { AsterChip } from 'asterX-UIkit/Chips'
import { colorStatusesByCode } from 'constants/constants'
import moment from 'moment'
import { EmptyLists } from '../EmptyLists/EmptyLists'

const Cards = ({ item, onClick }) => {
  const classes = useRequestCardStyles()

  const date = item?.createdDate
    ? moment(new Date(item?.createdDate)).format('HH:mm, DD.MM.YYYY')
    : '-'

  return (
    <Card className={classes.card} onClick={onClick}>
      <CardContent style={{ padding: 16 }}>
        <Typography
          className={classes.title}
        >{`Заявка №${item?.id}`}</Typography>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography className={classes.department}>
            {item?.department === 'AsterX' ? item?.department : item?.module}
          </Typography>
          <IconButton size="small">
            <ArrowForward />
          </IconButton>
        </div>
        <Typography className={classes.module}>
          {item?.department === 'AsterX' ? item?.module : ''}
        </Typography>
        <div style={{ marginBottom: 12 }}>
          <AsterChip
            label={item?.status || '-'}
            style={{
              ...colorStatusesByCode(item?.status),
              marginRight: 8
            }}
          />
          <AsterChip
            label={
              getNotification(
                item?.status,
                item?.unAnswered,
                item?.hadQuestionnaire
              ).text
            }
            style={{
              ...getNotification(
                item?.status,
                item?.unAnswered,
                item?.hadQuestionnaire
              ),
              borderRadius: 8,
              cursor: 'pointer'
            }}
          />
        </div>
        <Typography className={classes.responsible}>
          {item?.adminFullname || 'Ожидаем ответственного...'}
        </Typography>
        <Typography className={classes.module}>
          {item?.adminFullname && item?.department === 'Help desk'
            ? item?.department
            : ''}
        </Typography>
        <Typography className={classes.time}>{date}</Typography>
      </CardContent>
    </Card>
  )
}

const RequestCards = () => {
  const classes = useRequestCardStyles()
  const router = useRoutes()

  const {
    homeStore: { lists, wlTab, pagination },
    homeStoreFunc: { setWlTab, setSelectedStatus, getSupportList }
  } = useHomeStore()

  const handleOpen = id => {
    router.goTo(`${REQUEST_PATH}/${id}`)
  }

  const handleChangeTabs = (item, index) => {
    const status = item.code
    setWlTab(index)
    setSelectedStatus(status)
    getSupportList(status, pagination.offset, pagination.limit)
  }

  return (
    <>
      <Grid item container className={classes.filterTabs}>
        {tableStatusBtns.map((item, index) => {
          const isActive = wlTab === index

          return (
            <Grid item container key={`table_${index}`}>
              <Button
                className={clsx(
                  classes.tableStatusBtn,
                  isActive ? classes.tableStatusBtnActive : ''
                )}
                onClick={() => handleChangeTabs(item, index)}
              >
                {item.label}
              </Button>
            </Grid>
          )
        })}
      </Grid>
      <Grid container item>
        {!lists?.length && wlTab === 0 ? (
          <EmptyLists />
        ) : (
          (lists || []).map((item, idx) => (
            <Grid item xs={12} sm={12} md={12} lg={12} key={`request_${idx}`}>
              <Cards item={item} onClick={() => handleOpen(item.id)} />
            </Grid>
          ))
        )}
      </Grid>
    </>
  )
}

export default RequestCards
